<template>
	<v-alert :color="color" :icon="icon" dense border="left" colored-border tile>
		<span v-html="notification.message">{{ notification.message }}</span>
		<small>{{ notification.details }}</small>
	</v-alert>
</template>

<script>
import { mapActions } from "vuex";

export default {
	props: {
		notification: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			timeout: null,
			statusConfig: {
				allow: {
					color: "green darken-2",
					icon: "mdi-thumb-up",
				},
				error: {
					color: "red darken-2",
					icon: "mdi-close-circle",
				},
				unassigned: {
					color: "indigo",
					icon: "mdi-alert-circle",
				},
				disavowed: {
					color: "red darken-2",
					icon: "mdi-thumb-down",
				},
				disavow: {
					color: "red darken-2",
					icon: "mdi-thumb-down",
				},
				approved: {
					color: "green darken-2",
					icon: "mdi-thumb-up",
				},
				review: {
					color: "yellow darken-2",
					icon: "mdi-help-circle",
				},
				assigned: {
					color: "purple darken-2",
					icon: "mdi-account-plus",
				},
				userUpdated: {
					color: "teal darken-2",
					icon: "mdi-account-check",
				},
			},
		};
	},
	mounted() {
		this.timeout = setTimeout(() => this.remove(this.notification), 5000);
	},
	beforeDestroy() {
		clearTimeout(this.timeout);
	},
	computed: {
		config() {
			return this.statusConfig[this.notification.type];
		},
		color: function() {
			let color = this.config.color;
			return color ? color : null;
		},
		icon: function() {
			let icon = this.config.icon;
			return icon ? icon : null;
		},
	},
	methods: {
		...mapActions("notification", ["remove"]),
	},
};
</script>

<style scoped>
small {
	display: block;
	width: 20rem;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
</style>

<style lang="scss">
.v-alert--dense .v-alert__icon {
	margin-right: 8px !important;
}
</style>
